<template>
  <div class="container">
    <Container :active_path="'/reallyWillBuy/officeProducts'"
               :plate="'项目巡览'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search"
                   ref="form"
                   label-width="80px"
                   :inline="true"
                   size="normal">
            <el-form-item label="名称">
              <el-input v-model="search.title"
                        size="mini"
                        placeholder="请输入办公产品名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         size="mini"
                         @click="confirm">搜索</el-button>
              <el-button type="success"
                         size="mini"
                         @click="reset">重置</el-button>

              <el-button type="primary"
                         size="mini"
                         @click="addp">添加办公租赁产品</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <el-dialog v-bind="$attrs"
                     v-on="$listeners"
                     :visible.sync="dialogVisible"
                     title="办公产品"
                     width="40%">
            <el-row :gutter="24">
              <el-form ref="elForm"
                       :model="formData"
                       :rules="rules"
                       size="small"
                       label-width="100px"
                       label-position="left">
                <el-col :span="24">
                  <el-form-item label="产品标题"
                                prop="title">
                    <el-input v-model="formData.title"
                              placeholder="请输入产品标题"
                              show-word-limit
                              clearable
                              prefix-icon='el-icon-s-opportunity'
                              :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="产品标签"
                                prop="label">
                    <el-input v-model="formData.label"
                              placeholder="请输入产品标签"
                              show-word-limit
                              clearable
                              prefix-icon='el-icon-s-opportunity'
                              :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="图片列表"
                                prop="">
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadfilevsnologo/"
                               :on-success="phandleUploadSuccess"
                               :before-upload="beforeUpload"
                               :file-list="fileList"
                               :on-remove="handleRemove"
                               multiple
                               :limit="10"
                               list-type="picture">
                      <i class="el-icon-upload"></i>

                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip"
                           slot="tip">只能上传jpg/png文件，且不超过2M</div>

                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="设施服务"
                                prop="">
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadfilevsnologo/"
                               :on-success="facilityhandleUploadSuccess"
                               :before-upload="beforeUploads"
                               :file-list="facilityList"
                               :on-remove="handleRemoves"
                               multiple
                               :limit="10"
                               list-type="picture">
                      <i class="el-icon-upload"></i>

                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip"
                           slot="tip">只能上传jpg/png文件，且不超过2M</div>

                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目楼层"
                                prop="projectfloor">
                    <el-input v-model="formData.projectfloor"
                              placeholder="请输入项目楼层例如:8F/9F"
                              clearable
                              :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22">
                  <el-form-item label="项目面积"
                                prop="projectarea">
                    <el-input v-model="formData.projectarea"
                              placeholder="请输入项目面积例如: 6000m²"
                              clearable
                              :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="项目介绍">
                    <tin-editor :value="formData.content"
                                class="tin-editor"
                                @input="getcontent"></tin-editor>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="产品封面图">
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadfilevsnologo/"
                               :on-success="handleUploadSuccess"
                               :before-upload="beforeUpload"
                               multiple
                               :limit="1">
                      <i class="el-icon-upload"></i>

                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip"
                           slot="tip">只能上传jpg/png文件，且不超过1M</div>

                    </el-upload>
                  </el-form-item>
                  <div v-if="imageUrl"
                       style="text-align: center;"
                       class="el-upload__text">图片如下</em></div>

                  <img v-if="imageUrl"
                       :src="imageUrl"
                       class="avatar"
                       style="text-align: center;margin-bottom: 20px;">
                </el-col>
                <el-col>
                  <el-form-item label="项目位置">
                    <el-input v-model="formData.cellAddress"
                              placeholder="详细位置"
                              disabled />
                  </el-form-item>
                  <el-form-item label="经度">
                    <el-input v-model="formData.cellLongitude"
                              placeholder="经度"
                              disabled />
                  </el-form-item>
                  <el-form-item label="纬度">
                    <el-input v-model="formData.cellDimension"
                              placeholder="纬度"
                              disabled />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary"
                               @click="mapDialog">查询</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="15">
                  <el-form-item label="产品排序">
                    <el-input type="number"
                              v-model="formData.listorder"
                              placeholder="产品排序"></el-input>
                    <div>排序值 越小越靠前</div>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <div slot="footer">
              <el-button @click="close">取消</el-button>
              <el-button type="primary"
                         @click="handleConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 地图dialog 下一任记得换key 0.0 sb腾讯的 -->
        <el-dialog title="选择位置"
                   :visible.sync="mapDialogVisible"
                   width="800px"
                   center
                   :before-close="maphandleClose">
          <el-form label-width="40px"
                   :inline="true">
            <el-tag type="success">搜索后,请手动点击地图列表,完成选择</el-tag>
            <el-form-item label="搜索">

              <iframe id="mapPage"
                      width="700"
                      height="580"
                      frameborder="0"
                      src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=Z2WBZ-AQFLR-NQBWC-WWA3T-ZR7PT-NXF3C&referer=myapp" />
              <!-- <span id="gps1" /> -->
              <!-- <input id="gps" name="mdgps" type="hidden" value="loc.poiname"> -->
            </el-form-item>

          </el-form>
          <span slot="footer"
                class="dialog-footer">
            <el-button @click="mapcloseDialog">取 消</el-button>
            <el-button type="primary"
                       @click="getLoc">确 定</el-button>
          </span>
        </el-dialog>
        <div class="table-box">
          <el-table :data="tabledata"
                    border
                    size="mini"
                    :header-cell-style="{ background: '#f7f7f7', color: '#999', textAlign: 'center', fontWeight: 'normal' }">
            <el-table-column type="index"
                             label="序号"
                             width="60"></el-table-column>
            <el-table-column prop="title"
                             label="产品标题"
                             show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column prop="label"
                             label="标签"
                             show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column prop="listorder"
                             label="排序"
                             show-overflow-tooltip
                             align="center"></el-table-column>
            <el-table-column prop="pics"
                             label="封面图"
                             show-overflow-tooltip
                             align="center">
              <template slot-scope="s">
                <el-image style="width: 50px; height: 50px; margin-bottom:-4px;"
                          :src="s.row.pics" />
              </template>
            </el-table-column>
            <el-table-column prop="index"
                             label="操作"
                             width="210">
              <template slot-scope="s">
                <el-button type="warning"
                           v-if="s.row.putaway"
                           size="mini"
                           @click="putaway(s.row)">下架</el-button>
                <el-button type="success"
                           v-if="!s.row.putaway"
                           size="mini"
                           @click="putaway(s.row)">上架</el-button>
                <el-button type="danger"
                           size="mini"
                           @click="del(s.row)">删除</el-button>
                <el-button type="primary"
                           size="mini"
                           @click="edit(s.row)"
                           plain>编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="page-tion"
                       @current-change="currentChange"
                       layout="prev, pager, next"
                       :page-size="pagesize"
                       :total="total"
                       background>
        </el-pagination>
      </div>
    </Container>

    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import Container from "../../../components/container"
import TinEditor from '../../../components/tin-editor.vue'  // 富文本

export default {
  components: {
    Container, TinEditor
  },
  data () {
    return {
      fileList: [],
      facilityList: [],
      path: '/reallyWillBuy/bookAnOrder',
      plate: '办公租赁',
      search: {
        title: '',
      },
      dialogVisible: false,
      pageNo: 1,
      pagesize: 14,
      formData: {
        id: '',
        label: '',
        title: '',
        pics: '',
        listorder: '',
        photos: [],
        facility: [],
        projectarea: "",
        projectfloor: '',
        content: '',
        cellAddress: '', // 地址
        cellLongitude: '', // 经度
        cellDimension: '', // 纬度
      },
      options: [],//分类回显
      rules: {
        title: [{
          required: true,
          message: '请输入该办公产品名称',
          trigger: 'blur'
        }],
        projectfloor: [{
          required: true,
          message: '请输入该项目楼层',
          trigger: 'blur'
        }],  projectarea: [{
          required: true,
          message: '请输入该项目面积',
          trigger: 'blur'
        }],
        cellAddress: [{
          required: true, message: '请前往查询,并选择', trigger: 'blur'
        }]
      },
      tabledata: [],
      total: 0,
      imageUrl: '',
      mapDialogVisible: false,
      location: {}
    }
  },
  mounted () {

    this.getTableData();
    // this.getLease()
    const that = this // this 指向问题  可恶
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data
      if (loc && loc.module === 'locationPicker') {
        // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        that.location = loc
        // console.log(that.location, 'location')
        // console.log(loc, 'loc')

        // that.cellAddress = loc.cityname
        // that.cellLongitude = loc.latlng.lat
        // that.cellDimension = loc.latlng.lng
      }
    }, false)
  },
  methods: {
    handleRemove(file, fileList) {
      this.formData.photos.splice(this.formData.photos.index, 1)
      },
      handleRemoves(file, fileList) {
      this.formData.facility.splice(this.formData.facility.index, 1)
      },
    getcontent (content) {
      this.formData.content = content;
    },
    maphandleClose (done) {
      this.$confirm('确认取消位置选择么？')
        .then(_ => {
          done()
        })
        .catch(_ => { })
    },
    getLoc () {
      // console.log(this.location, '111')
      this.formData.cellAddress = this.location.poiaddress + this.location.poiname// this.location.cityname
      this.formData.cellLongitude = this.location.latlng.lat
      this.formData.cellDimension = this.location.latlng.lng
      // console.log(this.formData, 'formInline')
      this.mapDialogVisible = false
    },
    mapDialog () {
      this.mapDialogVisible = true
    },
    mapcloseDialog () {
      this.mapDialogVisible = false
      this.location = {}
    },
    // photos上传成功后
    phandleUploadSuccess (response, file, fileList) {
      // this.fileList=
      // console.log(this.formData.photos, '66666666666');
      let that = this
      that.formData.photos.push(response.data)

    },
    //设施服务上传成功后
    facilityhandleUploadSuccess (response, file, fileList) {
      // this.facilityList= facility
      // console.log(response, '66666666666');
      let that = this
      that.formData.facility.push(response.data)

    }, beforeUploads (file) {
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isAccept
    },
    addp () {
      this.dialogVisible = true
      this.formData = {}
      this.formData.photos = []
      this.formData.facility = []

      this.imageUrl = ''
      this.fileList = []
      this.facilityList = []

      this.formData.pics = ''
    },
    edit (row) {
      // console.log(row);
      this.dialogVisible = true
      this.fileList = []
      this.facilityList = []

      this.formData.photos = []
      this.formData.facility = []

      this.imageUrl = row.pics
      this.formData = row
      const img = row.photos
      for (var i = 0; i < img.length; i++) {
        var obj = {
          name: '',
          url: img[i]
        }
        this.fileList.push(obj)
      }
      const imgs = row.facility
      for (var a = 0; a < imgs.length; a++) {
        var obj2 = {
          name: '',
          url: imgs[a]
        }
        this.facilityList.push(obj2)
      }
    },
    close () {

      this.dialogVisible = false
    },
    handleConfirm () {
      this.$refs['elForm'].validate(valid => {
        if (valid) {
          // console.log(this.formData, '8888');
          var params = {
            id: this.formData.id,
            label: this.formData.label,
            title: this.formData.title,
            pics: this.formData.pics,
            listorder: this.formData.listorder,
            content: this.formData.content,
            photos: this.formData.photos,
            projectarea: this.formData.projectarea,
            projectfloor: this.formData.projectfloor,
            facility: this.formData.facility,
            cellAddress: this.formData.cellAddress, // 地址
            cellLongitude: this.formData.cellLongitude, // 经度
            cellDimension: this.formData.cellDimension, // 纬度
          }

          this.$api.proleaseAdd(params).then(res => {
            // console.log(res, '=====');
            if (res === '添加成功' || res === '修改成功') {
              this.$message.success(res);
              this.dialogVisible = false
            }
            this.getTableData();
            this.formData = {}
            this.imageUrl = ''

          })
        } else {
          this.$message.error('提交失败');
          // this.dialogVisible = false
          return false;
        }
      })
    },


    beforeUpload (file) {
      // let isRightSize = file.size / 1024 / 1024 < 1
      // if (!isRightSize) {
      //   this.$message.error('文件大小超过 1MB')
      // }
      let isAccept = new RegExp('image/*').test(file.type)
      if (!isAccept) {
        this.$message.error('应该选择image/*类型的文件')
      }
      return isAccept
    },
    // 文件上传成功时的钩子
    handleUploadSuccess (item, response) {
      let { data, errCode, msg } = response;
      // console.log(data, 'data');
      // console.log(item, 'item');

      if (item.msg === '上传成功') {
        this.$message.success('上传成功');
        this.formData.pics = item.data
        this.imageUrl = item.data

        this.$forceUpdate()
      } else {
        this.$message.error('上传失败');
      }
    },
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    //上下架
    putaway (row) {
      var params = {
        id: row.id,
        putaway: !row.putaway
      };
      this.$api.putawayprolease(params).then((data) => {
        this.$message.success(data);
        this.getTableData();
      });
    },
    del (row) {
      this.$confirm("是否确定删除" + row.title).then(
        (confirm) => {
          var params = {
            id: row.id
          };
          this.$api.delproleaseAdd(params).then((data) => {
            this.$message.success(data);
            this.getTableData();
          });
        },
        (cancel) => { }
      );
    },
    getTableData () {
      var params = {
        title: this.search.title
      }
      this.$api.grtproleaseAdd(params).then(data => {
        // console.log(data, '---');
        this.tabledata = data.list;
        this.total = data.total;
      })
    },
    reset () {
      this.search.title = ''
      this.getTableData()
    },
    // getLease () {
    //   this.$api.getclassselect().then(res => {
    //     this.options = res
    //   })
    // }
  },

}
</script>

<style lang="scss" scoped>
.el-rate {
  display: inline-block;
  vertical-align: text-top;
}

.el-upload__tip {
  line-height: 1.2;
}

.right-edit-box {
  position: absolute;
  right: 0;
  top: 0;
}

.el-carousel__item {
  background: #fff;
  border: 1px dashed #999;

  .img {
    width: 270px;
    height: 202px;
    vertical-align: middle;
    position: relative;
  }

  .name {
    position: absolute;
    color: #fff;
    padding: 0 6px;
    background: rgba(0, 0, 0, 0.4);
    bottom: 4px;
    left: 4px;
  }
}

.left-row {
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  margin: 0 auto;
}

.tin-editor {
  width: 100%;
}
</style>
<style scoped>
.image-upload {
  width: 100%;
}
</style>